import EntityView from "../../components/EntityView";
import MoleculeImage from "../../components/MoleculeImage";
import {
  MDCollapsibleText,
  MDCollapsibleList
} from "../../components/results-grid/grid-row/MDCollapsibleContent";

export const overrideMapSample = {
  Text: {
    component: MDCollapsibleText
  },
  List: {
    component: MDCollapsibleList
  },
  Ball: {
    component: EntityView,
    props: { showLabel: true, scale: "lg" }
  },
  SMILES: {
    component: MoleculeImage
  }
};
